var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{class:[_vm.childClass, 'btn btn-pdv-gradient-blue'],attrs:{"block":"","disabled":_vm.busy || _vm.disabled},on:{"click":function($event){return _vm.$emit('onClick')}}},[(_vm.busy)?[_c('b-spinner',{attrs:{"small":""}})]:[_vm._v(_vm._s(_vm.title ? _vm.title : _vm.getI18n('COMMON.save')))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }